import React from 'react'
import GPXLapCounter from './components/GPXLapCounter'

function App() {
  return (
    <div className="App">
      <GPXLapCounter />
    </div>
  )
}

export default App